import React from 'react';
import * as ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import autobind from 'autobind-decorator';
import { observer, inject } from 'mobx-react';
import { OneScroll } from '../../../components';
import {
    AppList,
    SkuSelectComp,
    Nav,
    Banner,
    SearchComp,
    FloorModule,
    Channel,
    ShortcutEntry,
    TimeMainGoods,
    TimeAxis
} from '../../../widgets';
import {
    RankList,
    NoPaginationList,
    RankDetail,
    SkoList,
    FloorList,
    Logistics,
    GetTipLayer,
    DecrementCount,
    GetTimerShaft
} from '../../../model';
import './Home.less';
import {
    tingYun,
    push,
    params2QueryString,
    _equipmentType,
    getUrlParam,
    get,
    // setShareConfig,
    // setShareReady
} from '../../../utils';
import store, { StatusStore, UserStore } from '../../../store';
// 暂时注释，不可删除
import { FloorTitle } from '../../../widgets/floorModule/floorTitle';
import { addShop, getWXSignature } from '../../../operates';
import { observable } from 'mobx';
import { getCookie, setCookie } from '../../../utils/network';


interface HomeState {
    rankView?: any;
    isTop: any;
    homey: number;
    isFixed: boolean;
    needFixed: boolean;
    productId: any;
    isShow: boolean;
    downHight: number;
    saveY: number;
    isShowHome: boolean;
    isShowHomeSheel: boolean;
    process_bar_width: number;
    isLoaded: boolean;
    GetTimerShaftData: any;
    shaftType: number;
    timeFixed: boolean;
    timeFixedFirst: boolean;
    navKey: any;
    bgType: any;
    searchValue: any;
    bannerValue: any;
    bgValue: any;
    firstInit: boolean;
}

interface HomePropType {
    prefixCls?: string;
    user: UserStore;
    status?: StatusStore;
}

declare var window: any;

/**
 * 1、首页容器组件
 */
class Home extends React.Component<HomePropType, HomeState> {
    static defaultProps = {
        prefixCls: 'home'
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            rankView: undefined,
            isTop: false,
            homey: 0,
            isFixed: false, // 是否定位
            productId: '',
            isShow: false,
            downHight: 0,
            saveY: 0,
            isShowHome: false,
            isShowHomeSheel: false,
            process_bar_width: 0,
            isLoaded: false,
            GetTimerShaftData: '',
            shaftType: 1,
            needFixed: false,
            timeFixed: false,
            timeFixedFirst: false,
            navKey: (Math.random()).toString(),
            bgType: "",
            searchValue: "",
            bannerValue: "",
            bgValue: "",
            firstInit: true
        };
    }

    refMap = {
        oneScroll: (any) => this.oneScroll = any,
        rankView: (obj) => this.setState({
            rankView: obj
        }),
        searchNode: (obj) => this.searchNode = obj,
    };
    window: any = window;
    oneScroll: any = OneScroll;
    searchNode: any = SearchComp;
    rankDetail: any = RankDetail; // 详情数据
    skoData: any = SkoList;
    getTipLayerData: any = GetTipLayer;
    tipLayerData: any = '';
    selectSkuId: any = ''; // 选中的skuID
    skoDataObj: any = {}; // 选中的skuID
    tabArrList: any = [];// 频道列表
    quickEnter: any = new Logistics({ url: 'home/v1/quickEnter' }); // 快捷入口
    @observable timeAxisList: any = {};
    @observable timeCurrent: any = 0;
    @observable htmlId: any;
    getTimerShaft: any;
    goodsList: any = [];
    isFixedRender = true;
    timeThemeList: any = [];

    componentWillMount() {
        let init_url: any = window.location.href
        let user_agent = navigator.userAgent.toLowerCase();
        if (/iphone|ipad|ipod/.test(user_agent)) {   //iphone
            if (init_url.includes('?#!') && !init_url.includes('&share')) {
                init_url = init_url.split('?#!')
                init_url = init_url[0] + '#!' + init_url[1]
            }
        }
        if (init_url) {
            sessionStorage.setItem('init_url', init_url);
        }
        store.status.isGameAppdetail = false;
        document.title = '国孕商城';
        let channelState = store.classification.channelState;
        const isRequest = channelState == 'initial' ? true : false;
        if (getUrlParam("isIosApp") !== "") {
            sessionStorage.setItem("isIosApp", "1")
            sessionStorage.setItem("iosCBUrl", getUrlParam("isIosApp")) // ios App微信支付回调地址
        }
        if (window.homey) {
            this.setState({
                homey: window.homey
            });
        }
        if (!window.homeList || isRequest) {
            window.homeList = new RankList({ url: 'newproduct/v1/list' }); // 精选好货
        }
        if (!window.bannerList || isRequest) {
            window.bannerList = new NoPaginationList({ url: 'regions/v1/bannerList' }); // 轮播
            window.bannerList.fetch();
        }
        if (!window.floorList || isRequest) {
            window.floorList = new FloorList({ url: 'floor/v1/floorList' }); // 轮播下边精选好货上边
            window.floorList.fetch();
        }
        this.tabArrList = new FloorList({ url: 'regions/v1/getClassInfo', level: 1, classType: 1 }); //轮播上边tab
        this.tabArrList.fetch((data) => {
            this.setState({
                isShowHome: true
            });
            let channelState = store.classification.channelState;
            for (let i = 0; i < data.length; i++) {
                if (data[i].id == channelState || channelState == 'channel') {
                    return;
                }
            }
            channelState && store.classification.setChannelSate('initial');
            channelState && store.classification.setInitialSlide(0);
        });
        this.getTipLayerData = new GetTipLayer({ url: 'home/v1/getTipLayer' });
        let that = this;
        that.getTipLayerData.fetch(function (data) {
            that.tipLayerData = data;
            if (that.tipLayerData == '' || that.tipLayerData == null || that.tipLayerData.tipImg == null) {
                that.setState({
                    isShowHomeSheel: false,
                });

            } else {
                that.setState({
                    isShowHomeSheel: true,
                });
            }
            return data;
        });
        if (getUrlParam('type')) {
            this.getTimerShaft = new GetTimerShaft({
                url: 'newproduct/v1/list/getShareTimerShaft',
                type: getUrlParam('type'),
                date: getUrlParam('date'),
                shaftId: getUrlParam('shaftId')
            });
        } else {
            this.getTimerShaft = new GetTimerShaft({ url: 'newproduct/v1/list/getTimerShaft', type: 0 });
        }
        this.getTimerShaft.fetch((data) => {
            this.timeAxisList = data;
            for (let i = 0; i < this.timeAxisList.navigat.length; i++) {
                if (this.timeAxisList.navigat[i].center == 1) {
                    this.timeCurrent = i;
                    sessionStorage.setItem('timeCurrent', this.timeCurrent);
                    return;
                }
            }
        });
        this.getBackground()
        //获取微信签名
        this.getSignature();
    }

    componentDidMount() {
        let that = this;
        var deviceWidth = document.documentElement.clientWidth;
        // if (deviceWidth >= 1080) { deviceWidth = 1080; }
        document.documentElement.style.fontSize = deviceWidth / 38 + "px";
        that.setState({
            isLoaded: true
        });
        // 快捷入口
        this.quickEnter.fetch();
        tingYun.setTingYun('home');
        // burialPoint('burialpoint/logIndexAndSubject', {body: JSON.stringify(this._setBurialPoint())});
        store.status.appTitle = '国孕商城';
        store.status.isShowLeftBackBtn = false;
        store.status.rightBtnType = 'backHall';
        // 首席看护人免登录开始
        let token = getUrlParam("token")
        let mobile = getUrlParam("mobile")
        let isCaretaker = getUrlParam("isCaretaker")
        if (isCaretaker !== "") {
            sessionStorage.setItem("isCaretaker", isCaretaker)
            sessionStorage.setItem("token", token)
            sessionStorage.setItem("mobile", mobile)
            get(`user/v2/mobile/login/web/NoSecret?mobile=${mobile}&isCaretaker=${isCaretaker}&token=${token}`).then(res => {
                if (res.data != null && res.errCode == 200) {
                    setCookie("pub-token", res.data.token, 3)
                }
            })
        }
        // 首席看护人免登录结束
    };
    async getSignature() {
        let name = (store.user.shopInfo && store.user.shopInfo.name) ? store.user.shopInfo.name : '国孕商城';
        let avatar = (store.user.shopInfo && store.user.shopInfo.avatar) ? store.user.shopInfo.avatar : 'https://static.gjyunying.com/upload/share/share.png';
        let shareUrl = sessionStorage.getItem("init_url") //window.location.href.split('?#!')[0]
        let user_agent = navigator.userAgent.toLowerCase();
        if (/iphone|ipad|ipod/.test(user_agent)) {   //iphone
            avatar = decodeURIComponent(avatar)
        }
        let shareInfo = {
            shareTitle: '推荐给您一个不错的店铺: ' + name,
            shareDesc: '欢迎光临小店',
            shareUrl, //getUrlParam('partnerId') ? window.location.href : window.location.href + '&partnerId=' + store.user.partnerId,
            sharePic: avatar
        };
        await getWXSignature(shareInfo.shareTitle, shareInfo.shareDesc, shareInfo.shareUrl, shareInfo.sharePic)
    }

    /* 首页埋点 */
    _setBurialPoint(data?: any): Object {
        let headerObj: object = data ? {
            user: {
                userType: 1,
                serviceType: 'C',
                osTypeId: _equipmentType(),
            },
            actionType: 4,
            clickInfo: {
                type: data.type,
                bannerId: data.bannerId,
                picUrl: data.picUrl
            }
        } : {
            user: {
                userType: 1,
                serviceType: 'C',
                osTypeId: _equipmentType(),
            },
            page: {
                pageId: 'index',
                originPageId: getUrlParam('originPageId') || '',
            }
        };
        return headerObj;
    }

    @autobind
    onHomey(name) {
        this.setState({
            homey: name
        });
        window.homey = name;
    }

    //关闭及点击首页弹层调用的接口
    @autobind
    clickCloseAlert(id) {
        new DecrementCount({ tipId: id, url: 'home/v1/decrementCount' }).fetch((data) => {

        });
    }

    // 首页快捷入口点击事件
    @autobind
    onEntryClick(item) {
        if (item.type === 0) {
            // 查询productId
            new RankDetail({ skuCode: item.content, url: 'newproduct/v1/getProSkuId' }).fetch(null, data => {
                sessionStorage.setItem('__skuId', data.skuId);
                push(`/appdetail/${data.productId}?originPageId=index&originType=3`, this);
            });
        } else if (item.type === 1) {
            location.href = `${item.content}?originPageId=index`;
        }
    }

    @autobind
    renderContent() {
        const { status } = this.props;
        const homeSkin: any = status && status.getHomeSkin;
        let channelState = store.classification.channelState;
        const isShowFloor = channelState && channelState != 'channel' && channelState != 'initial' ? false : true;
        let bgData: any = homeSkin[0] ? homeSkin[0].pageVO : {};
        let bgStyle: any = {};
        if (bgData) {
            bgStyle = {
                floorGapColour: bgData.floorGapColour,
            };
        }
        return (
            <div>
                {
                    window.bannerList.list.length > 0 &&
                    <Banner
                        style={{
                            background: this.state.bgType === 1 ? this.state.bannerValue : `url(${this.state.bannerValue}) 0% 0% / 100% 100% no-repeat`,
                            // backgroundSize: '100% 100%'
                        }}
                        bannerList={window.bannerList.list}
                        onClick={this.onBannerClick}
                        isRecommend={isShowFloor}
                    />
                }
                {
                    isShowFloor && this.quickEnter.logisticsData && (
                        <ShortcutEntry
                            onEntryClick={this.onEntryClick}
                            data={this.quickEnter.logisticsData || []}
                            bgData={bgData}
                        />
                    )
                }
                {
                    isShowFloor && window.floorList.list && window.floorList.list.length > 0 && window.floorList.list.map(item => {
                        return (
                            <div>
                                <FloorModule
                                    floorItem={item}
                                    key={item.id}
                                    onFloorClick={this.onFloorClick}
                                    bgData={bgData}
                                />
                                <div className={`floorModule-space`}
                                    style={bgData ? { background: bgStyle.floorGapColour } : {}} />
                            </div>

                        );
                    })
                }
                {/* 暂时注释，不可删除 */}
                {
                    isShowFloor && (this.timeAxisList.navigat && this.timeAxisList.navigat.length > 0) && (
                        <div id='isFix'>
                            {
                                !this.state.timeFixed ?
                                    <TimeAxis
                                        navigat={this.timeAxisList && this.timeAxisList.navigat}
                                        onClick={this.onTimeAxisClick}
                                        currentIndex={this.timeCurrent}
                                        timeFixed={this.state.timeFixed}
                                        transformClass={'swiper-container-other-timer'}
                                    />
                                    : <div style={{ height: '6.6rem' }} />
                            }
                            <TimeMainGoods
                                goodsList={this.timeAxisList && this.timeAxisList.timer}
                                onAddShop={this.onAddShop}
                                toAppDetail={this.toApptaile}
                                onSpecialClick={this.onSpecialClick}
                                type={this.state.shaftType}
                            />
                        </div>
                    )
                }
                {/* 暂时注释，不可删除 */}
                {
                    isShowFloor && window.floorList.list && window.floorList.list.length > 0 &&
                    <div style={{ marginTop: '.8rem' }}>
                        <FloorTitle floorName={'精选好货'} />
                    </div>
                }
            </div>
        );
    }

    // 时间轴切换
    @autobind
    onTimeAxisClick(item, index) {
        this.timeCurrent = index;
        this.setState({
            shaftType: item.type
        });
        let obj: any = { url: 'newproduct/v1/list/getTimerShaft', type: item.type };
        item.type === 0 && Object.assign(obj, { shaftId: item.shaftId });
        this.htmlId = item.shaftId ? item.shaftId : '';
        this.getTimerShaft = new GetTimerShaft(obj);
        this.getTimerShaft.fetch((data) => {
            this.timeAxisList = data;
        });
    }

    // 跳转至专题
    @autobind
    onSpecialClick(data) {
        location.href = `${data}?originPageId=index`;
    }

    // 时间轴商品加入购物车
    @autobind
    onAddShop(data) {
        let obj: any = {
            data: data.skuId,
            selectNumber: 1
        };
        if (getCookie("pub-token") === "") {
            sessionStorage.setItem("addShopData", JSON.stringify(obj))
            sessionStorage.setItem('oldPage', `home`)
            push("/loginPage/addShop?originPageId=home", this)
        } else {
            addShop(obj, this.props.user, (isRun) => {
                if (isRun) return;
                let skuIdStr: any = sessionStorage.getItem('__shop');
                if (skuIdStr) {
                    skuIdStr.indexOf(data.skuId) == -1 && sessionStorage.setItem('__shop', skuIdStr + ',' + data.skuId);
                } else {
                    sessionStorage.setItem('__shop', data.skuId);
                }
            });
        }
        this.setState({
            navKey: (Math.random()).toString()
        })
        // burialPoint('burialpoint/logShopCar', {
        //     body: JSON.stringify(this._transformBurialPointData({
        //         skuId: obj.data,
        //         productPrice: data.price,
        //         pageProductId: data.productId
        //     }))
        // });
    }


    @autobind
    onBannerClick(item): void {
        let that = this;
        if (item.bannerType == 2) {
            location.href = `${item.productSku}?originPageId=index`;
        } else {
            new RankDetail({ skuCode: item.productSku, url: 'newproduct/v1/getProSkuId' }).fetch(null, data => {
                sessionStorage.setItem('__skuId', data.skuId);
                // burialPoint('burialpoint/logBannerAndFloor', {
                //     body: JSON.stringify(that._setBurialPoint({
                //         type: 1,
                //         bannerId: data.banner_id,
                //         picUrl: data.imgUrl
                //     }))
                // });
                sessionStorage.setItem('isApp', 'false')
                push(`/appdetail/${data.productId}?originPageId=index&originType=3`, that);
            });
        }
    }

    /* 首页埋点 */
    _setFloorBurialPoint(id?: any, picUrl?: any): Object {
        let floorObj: object = {
            user: {
                userType: 1,
                serviceType: 'C',
                clientType: store.status.gameApp ? 3 : 4,
                osTypeId: _equipmentType(),
                appId: store.status.gameId ? store.status.gameId : ''
            },
            actionType: 6,
            clickInfo: {
                type: 2,
                floorId: id,
                picUrl: picUrl
            }
        };
        return floorObj;
    }

    @autobind
    onFloorClick(floorId: any, floorImgUrl: any, moduleType: any, moduleUrl: any) {
        let that = this;
        // burialPoint('burialpoint/logBannerAndFloor', {body: JSON.stringify(that._setFloorBurialPoint(floorId, floorImgUrl))});
        if (moduleType === 1) {
            // 根据sku编码获取商品id和skuid接口
            new RankDetail({ skuCode: moduleUrl, url: 'newproduct/v1/getProSkuId' }).fetch('floor', data => {
                sessionStorage.setItem('__skuId', data.skuId);
                push(`/appdetail/${data.productId}`, that);
            });
        } else if (moduleType === 2) {
            // 去专题页面moduleUrl
            location.href = `${moduleUrl}?originPageId=index`;
        }
    }

    @autobind
    onChannelClick(item) {
        const channelState = store.classification.channelState;
        const isShowFloor = channelState && channelState != 'channel' && channelState != 'initial' ? false : true;
        if (item) {
            let id = item.id;
            let uuidId = item.uuidId;
            window.homeList = new RankList({
                url: 'searchapi/category/' + 1 + '/' + uuidId,
                type: 1,
                categoryId: uuidId
            });
            window.bannerList = new NoPaginationList({ url: 'regions/v1/bannerList', channel: id });
            window.bannerList.fetch();
            let domNode: any = document.getElementById('oneScroll_unMount');
            ReactDOM.unmountComponentAtNode(domNode);
            setTimeout(() => {
                ReactDOM.render(<OneScroll
                    style={
                        this.tabArrList.list.length > 0 ?
                            {
                                background: '#FFF',
                                top: store.status.isShowHead ? (isShowFloor ? '9rem' : '6rem') : (isShowFloor ? '8.8rem' : '8.8rem')
                            } :
                            {
                                background: '#FFF',
                                top: store.status.isShowHead ? (isShowFloor ? '9rem' : '7rem') : (isShowFloor ? '0' : '5rem')
                            }
                    }
                    ref={this.refMap.oneScroll}
                    renderContent={this.renderContent}
                    fetchable={window.homeList}
                    freeHeight={5 + 'rem'}
                    renderItem={this.renderItem}
                    myY={0}
                    onHomey={this.onHomey}
                    showLoading={this.showLoading}
                    isToTop
                    onScroll={this.onScroll}
                    bgValue={this.state.bgType}
                />, domNode);
            }, 0);
        } else if (!item) {
            window.homeList = new RankList({ url: 'newproduct/v1/list' });
            window.bannerList = new NoPaginationList({ url: 'regions/v1/bannerList', channel: '-1' });
            window.bannerList.fetch();
            let domNode: any = document.getElementById('oneScroll_unMount');
            ReactDOM.unmountComponentAtNode(domNode);
            setTimeout(() => {
                ReactDOM.render(<OneScroll
                    style={
                        this.tabArrList.list.length > 0 ?
                            {
                                background: '#FFF',
                                top: store.status.isShowHead ? (isShowFloor ? '9rem' : '6rem') : (isShowFloor ? '8.8rem' : '8.8rem')
                            } :
                            {
                                background: '#FFF',
                                top: store.status.isShowHead ? (isShowFloor ? '9rem' : '7rem') : (isShowFloor ? '0' : '5rem')
                            }
                    }
                    ref={this.refMap.oneScroll}
                    renderContent={this.renderContent}
                    fetchable={window.homeList}
                    freeHeight={5 + 'rem'}
                    renderItem={this.renderItem}
                    myY={0}
                    onHomey={this.onHomey}
                    showLoading={this.showLoading}
                    isToTop
                    onScroll={this.onScroll}
                />, domNode);
            }, 0);
        }
        this.forceUpdate();
    }

    @autobind
    renderItem(data, index) {
        return data && (
            <AppList
                data={data}
                key={index}
                shopHomeJia={(data) => {
                    this.shopHomeJia(data);
                }}
                toApptaile={this.toApptaile}
                date={data.skuItems[0].promotStatus === 1 ? (data.skuItems[0].startTime || 0) : (data.skuItems[0].endTime || 0)}
                promotStatus={data.skuItems[0].promotStatus}
                type={data.skuItems[0].type}
            />
        );
    }

    @autobind
    toApptaile(productId) {
        if (sessionStorage.getItem('__selectSkuId')) {
            sessionStorage.removeItem('__selectSkuId');
        }
        if (sessionStorage.getItem('__selPropInfo')) {
            sessionStorage.removeItem('__selPropInfo');
        }
        push('/appdetail/' + productId + '?' + params2QueryString({ originType: 3, originPageId: 'index' }, {}), this);

    }

    @autobind
    onScroll(y) {
        let that = this;
        if (window.document.getElementById('isFix')) {
            const fixedTop = window.document.getElementById('isFix').offsetTop;
            const fixedHeight = window.document.getElementById('isFix').clientHeight;
            if (y > (fixedTop) && y < (fixedTop + fixedHeight)) {
                that.setState({
                    timeFixed: true,
                });
                this.isFixedRender = true;
            }
            if (y < (fixedTop)) {
                that.setState({
                    timeFixed: false,
                });
            }
            if (y > (fixedTop + fixedHeight - 100) && this.isFixedRender) {
                that.setState({
                    timeFixed: false
                });
                this.isFixedRender = false;
            }
        }
    }

    @autobind
    shopHomeJia(data) {
        this.shopHomeJiaFunc(data);
    }

    // 加入购物车逻辑处理
    @autobind
    shopHomeJiaFunc(data) {
        // let that = this;
        if (data.specifications === 1) { // 统一规格
            let obj: any = {
                data: data.skuItems[0].skuId,
                selectNumber: 1
            };
            if (getCookie("pub-token") === "") {
                sessionStorage.setItem("addShopData", JSON.stringify(obj))
                push("/loginPage/addShop?originPage=home", this)
            } else {
                addShop(obj, this.props.user, (isRun) => {
                    if (isRun) return;
                    let skuIdStr: any = sessionStorage.getItem('__shop');
                    if (skuIdStr) {
                        skuIdStr.indexOf(data.skuItems[0].skuId) == -1 && sessionStorage.setItem('__shop', skuIdStr + ',' + data.skuItems[0].skuId);
                    } else {
                        sessionStorage.setItem('__shop', data.skuItems[0].skuId);
                    }
                });
            }
            // burialPoint('burialpoint/logShopCar', {
            //     body: JSON.stringify(that._transformBurialPointData({
            //         skuId: obj.data,
            //         productPrice: data.minPrice,
            //         pageProductId: data.productId
            //     }))
            // });
        } else {
            let that = this;
            let d = data;
            this.setState({
                productId: d.productId
            });
            this.rankDetail = new RankDetail({
                url: 'newproduct/v1/detail',
                productId: d.productId,
                partnerId: that.props.user.partnerId
            });
            that.rankDetail.fetch(null, function (data) {
                if (data.productInfo.specifications === 1) { // specifications ===1 统一规格
                    that.selectSkuId = data.productInfo.skuItems[0].skuId;
                } else {
                    that.skoData = new SkoList({ url: 'newproduct/v1/sku/selector', productId: d.productId });
                    that.skoData.fetch(function (data) {
                        that.skoDataObj = data;
                        that.setState({
                            isShow: true,
                        });
                        return data;
                    });
                }
            });
        }
        this.setState({
            navKey: (Math.random()).toString()
        })
    }

    _transformBurialPointData(obj: any = {}): Object {
        let newObj: Object = {
            user: {
                userType: 1,
                serviceType: 'C',
                clientType: store.status.gameApp ? 3 : 4,
                osTypeId: _equipmentType(),
            },
            page: {
                pageId: 'product',
                originPageId: '',
            },
            product: {
                pageProductId: obj.pageProductId,
                originType: 3,
                addShopCart: 2,
                skuId: obj.skuId,
                productPrice: obj.productPrice,
            }
        };
        return newObj;

    }

    @autobind
    hideHomeJia(navKey = (Math.random()).toString()) {
        this.setState({
            isShow: false,
            navKey,
        }, () => { });
    }

    @autobind
    toOther(url) {
        if (this.tipLayerData.content.indexOf('http') == -1 && !store.status.gameApp) {
            new RankDetail({ skuCode: this.tipLayerData.content, url: 'newproduct/v1/getProSkuId' }).fetch(null, data => {
                push(`/appdetail/${data.productId}?originPageId=index&originType=3`, this);
            });
        } else if (this.tipLayerData.content.indexOf('http') == -1 && store.status.gameApp) {
            new RankDetail({ skuCode: this.tipLayerData.content, url: 'newproduct/v1/getProSkuId' }).fetch(null, data => {
                push(`/appdetail/${data.productId}?originPageId=index&originType=3&gameApp=true`, this);
            });
        } else {
            window.location.href = url;
        }

        this.clickCloseAlert(this.tipLayerData.id);
    }

    @autobind
    clickMethods() {
        if (this.state.isShowHomeSheel) {
            this.setState({
                isShowHomeSheel: false,
            });
            this.clickCloseAlert(this.tipLayerData.id);
        }
    }

    // 跳转搜索页
    @autobind
    onSearchClick() {
        if (localStorage.searchStartKey) {
            localStorage.removeItem('searchStartKey');
        }
        push('/searchStart', this);
    }

    @autobind
    showLoading() {
        // 下拉刷新重新调用banner接口
        window.bannerList.fetch();
        window.floorList.fetch();
    }

    getBackground = () => {
        get("regions/v1/getBgImgByType?type=1").then(res => {
            if (res.errCode == 200) {
                let data = res.data
                this.setState({
                    bgType: data.bgType,
                    searchValue: data.searchValue,
                    bannerValue: data.bannerValue,
                    bgValue: data.bgValue,
                })
            }
        })
    }
    render() {
        let { prefixCls } = this.props;
        let { isShowHome } = this.state;
        const channelState = store.classification.channelState;
        const isShowFloor = channelState && channelState != 'channel' && channelState != 'initial' ? false : true;
        return (
            <div>
                <div style={{
                    display: this.state.isLoaded ? 'block' : 'none',
                    paddingTop: store.status.isShowHead ? '5.7rem' : ''
                }}>
                    {
                        isShowHome ?
                            <div>
                                <div
                                    className={`${prefixCls}-topBox clearfix`}
                                    style={{
                                        top: store.status.isShowHead ? '5rem' : '',
                                        background: this.state.bgType === 1 ? this.state.searchValue : `url(${this.state.searchValue}) 0% 0% / 100% 100% no-repeat`,
                                        backgroundSize: '100% 100%'
                                    }}
                                >
                                    <SearchComp
                                        ref={'searchNode'}
                                        onClick={() => {
                                            this.onSearchClick();
                                        }}
                                        data={this.props.user ? this.props.user.shopInfo : {}}
                                    />
                                </div>

                                <div
                                    className={`${prefixCls}`}
                                    style={{ position: 'relative', top: store.status.isShowHead ? '5.1rem' : '4.7rem', paddingLeft: 0, paddingRight: 0 }}
                                >
                                    <div
                                        className={`${prefixCls}-floor clearfix`}
                                        style={{
                                            top: store.status.isShowHead ? '5rem' : '',
                                            background: this.state.bgType === 1 ? this.state.searchValue : `url(${this.state.searchValue}) 0% 0% / 100% 100% no-repeat`,
                                            backgroundSize: '100% 100%'
                                        }}
                                    >
                                        {
                                            this.tabArrList.list && this.tabArrList.list.length > 0 &&
                                            <Channel
                                                // style={{ background: this.state.bgType === 1 ? this.state.bannerValue : `url(${this.state.bannerValue})` }}
                                                tabArrList={this.tabArrList.list}
                                                onChannelClick={this.onChannelClick}
                                                isShowFloor={isShowFloor}
                                            />
                                        }
                                        {
                                            this.state.timeFixed &&
                                            <TimeAxis
                                                navigat={this.timeAxisList && this.timeAxisList.navigat}
                                                onClick={this.onTimeAxisClick}
                                                currentIndex={this.timeCurrent}
                                                timeFixed={this.state.timeFixed}
                                                transformClass={'swiper-container-other-timer2'}

                                            />
                                        }
                                    </div>
                                    <div id='oneScroll_unMount'>
                                        <OneScroll
                                            style={
                                                this.tabArrList.list.length > 0 ?
                                                    {
                                                        background: this.state.bgValue,
                                                        backgroundSize: '15rem',
                                                        top: store.status.isShowHead ? (isShowFloor ? '9rem' : '6rem') : (isShowFloor ? '8.8rem' : '8.8rem'),
                                                        // zIndex: 9999
                                                    } :
                                                    {
                                                        background: this.state.bgValue,
                                                        backgroundSize: '15rem',
                                                        top: store.status.isShowHead ? (isShowFloor ? '9rem' : '7rem') : (isShowFloor ? '3.7rem' : '3.7rem'),
                                                        // zIndex: 9999
                                                    }
                                            }
                                            ref={'onScroll'}
                                            renderContent={this.renderContent}
                                            fetchable={window.homeList}
                                            freeHeight={5 + 'rem'}
                                            renderItem={this.renderItem}
                                            myY={this.state.homey}
                                            onHomey={this.onHomey}
                                            showLoading={this.showLoading}
                                            isToTop
                                            onScroll={this.onScroll}
                                        />
                                    </div>
                                </div>
                            </div>
                            :
                            <div className={`${prefixCls}-loading`} />
                    }
                    <Nav key={this.state.navKey} />
                    {
                        this.state.isShow ?
                            <SkuSelectComp
                                user={this.props.user}
                                productId={this.state.productId}
                                hideHomeJia={() => {
                                    this.hideHomeJia();
                                }}
                                isShow={this.state.isShow}
                                selectSkuId={this.selectSkuId}
                                skoData={this.skoDataObj}
                                rankDetail={this.rankDetail}
                                pageId={'index'}
                            />
                            : null
                    }
                </div>
                <div className='loading1' style={{ display: this.state.isLoaded ? 'none' : 'block' }}>
                    <div className='process_view'></div>
                    <div className='process_bar' style={{ width: this.state.process_bar_width + 'rem' }}></div>
                    <div className='process_text'>更新中请稍后</div>
                </div>
                {
                    this.state.isShowHomeSheel &&
                    <div className={'homeShells'}>
                        <div className={'homeShells-area-container'} />
                        <img src={this.tipLayerData.tipImg} className={'homeShells-img-area'} onClick={() => {
                            this.toOther(this.tipLayerData.content);
                        }} alt="" />
                        <img src={require('../../../images/homeShellClose.png')} className={'homeShells-homeShellClose'}
                            onClick={() => {
                                this.clickMethods();
                            }} alt="" />
                    </div>
                }
            </div>
        );
    }

    static contextTypes = {
        router: PropTypes.object
    };

    componentWillUnmount() {
        tingYun.endTingYun();

    }
}


export default inject('user', 'status')(observer(Home));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/index/home/Home.tsx